import React from 'react';
import { Route, Redirect, RouteComponentProps } from 'react-router-dom';

import RoutesConstants from '@Constants/routes.constants';
import Base from '@Containers/Base';
import { selectAuthState } from '@Selectors/auth.selector';
import { useAppSelector } from '@Utils/hooks/useStore.hook';

import ProtectedRouteProps from './ProtectedRoute.types';

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  component: Component,
  path,
  exact = false,
  requiredRoles,
  ...rest
}) => {
  const authState = useAppSelector(selectAuthState);
  const isAuthenticated = authState?.isLoggedIn as boolean;
  const userRole = authState?.role;
  const userHasRequiredRole: boolean = userRole
    ? requiredRoles.includes(userRole)
    : false;

  return (
    <Route
      exact={exact}
      path={path}
      {...rest}
      render={(props: RouteComponentProps) =>
        isAuthenticated && userHasRequiredRole ? (
          <Base main={<Component {...props} />} />
        ) : (
          <Redirect
            to={{
              pathname: RoutesConstants.GLOBAL_ROUTES.BASE,
              state: {
                requestedPath: path,
                from: props.location,
              },
            }}
          />
        )
      }
    />
  );
};

export default ProtectedRoute;
